import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent, DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { AuthService } from 'src/app/base/services/auth.service';
import { ClientService } from 'src/app/base/services/client/client.service';
import { UserExtractFormType } from './user-extract-form-type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-user-extract-form',
    templateUrl: './user-extract-form.component.html',
    styleUrls: ['./user-extract-form.component.scss'],
    imports: [ReactiveFormsModule, DatePickerModule, TranslateModule]
})
export class UserExtractFormComponent  implements OnInit, OnDestroy {
  @ViewChild('startTime')
  public startTimePicker: DatePickerComponent;

  @ViewChild('endTime')
  public endTimePicker: DatePickerComponent;

  @Input() public form: FormGroup<UserExtractFormType>;

  @Output()
  public searchDTOChanged = new EventEmitter<any>();

  public keyValueDropdownSettings = {text: 'name', value: 'id'};

  public subscriptions = [];

  constructor(public authService: AuthService,
              protected clientService: ClientService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.form.valueChanges.subscribe(() => {
        if (this.endTimePicker) {
          if (this.form.controls.startDate.value) {
            this.endTimePicker.min = this.form.controls.startDate.value;
          } else {
            this.endTimePicker.min = null;
          }
        }

        if (this.startTimePicker) {
          if (this.form.controls.endDate.value) {
            this.startTimePicker.max = this.form.controls.endDate.value;
          } else {
            this.startTimePicker.max = null;
          }
        }

        this.searchDTOChanged.emit();
      }));
  }

  public get allowClientSelection(): boolean {
    return this.authService.isUserAdminOrClientAdmin() || this.authService.hasUserClientAssigned();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
